import { ILoyaltyGenerateOtpMutationVariables } from 'generated/graphql-gateway';

export enum ShortCodeState {
  None = 'NONE',
  Pending = 'PENDING',
  Expired = 'EXPIRED',
  RequestError = 'REQUEST_ERROR',
  Claimed = 'CLAIMED',
}

export interface IShortCodeData {
  shortCode?: string;
  expiry?: string;
}

export interface IUserShortCode {
  shortCode?: string;
  shortCodeState: ShortCodeState;
  shortCodeLoading: boolean;
  getNewShortCode: (params: ILoyaltyGenerateOtpMutationVariables) => void;
  setShortCodeClaimed: () => void;
  resetShortCode: () => void;
}
